<template>
  <multiselect
    v-model="localEditList"
    tag-placeholder="Add this as new Tag/Keyword"
    placeholder="Search or add a Tag/Keyword"
    label="name"
    track-by="id"
    :options="options"
    :multiple="true"
    :taggable="true"
    @tag="addTag"
  >
    <template slot="noResult">
      <span>No results found</span>
    </template>
    <template slot="tag" slot-scope="{ option, remove }">
      <span class="custom_multiselect_tag_style">
        <span>{{ option.name }}</span>
        <span class="cursor-pointer" @click="remove(option)"><i class="fa fa-times text-muted"></i></span>
      </span>
    </template>
  </multiselect>
</template>

<script>
import Multiselect from "vue-multiselect"

export default {
	name: "MultipleSelectTaggingSection",
	components: { Multiselect },
	props: ["editList", "options"],
	data() {
		return {
			localEditList: this.editList,
		}
	},
	watch: {
		localEditList(values) {
			this.$root.$emit("multipleSelectTaggingChange", values)
		},
	},
	methods: {
		addTag(newValue) {
			const newValues = newValue.split(",").map((value) => value.trim())
			newValues.forEach((newValue, index) => {
				const existingOption = this.options.find((option) => option.name.toLowerCase() === newValue.toLowerCase())
				if (!existingOption) {
					const newOption = {
						name: newValue,
						id: null,
					}
					this.localEditList.push(newOption)
					this.options.push(newOption)
				} else {
					const existingLocalEditList = this.localEditList.find(
						(option) => option.name.toLowerCase() === existingOption.name.toLowerCase(),
					)
					if (!existingLocalEditList) {
						this.localEditList.push(existingOption)
					}
				}
			})
		},
	},
}
</script>
